import { render, staticRenderFns } from "./firmar-dictamen-snp.vue?vue&type=template&id=5e054caa&"
import script from "./firmar-dictamen-snp.component.ts?vue&type=script&lang=ts&"
export * from "./firmar-dictamen-snp.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports